'use client';

import { useState } from 'react';

import { Button } from '@/components/ui/button';
import { useSession } from '@/shared/hooks/use-session';
import { Test401Button } from './test-401-button';
import { CopyTokensHelper } from './copy-tokens-helper';

export const DebugPanel = () => {
  const [isVisible, setIsVisible] = useState(false);
  const { session, token, user } = useSession();

  // Показываем только в development режиме
  if (process.env.NODE_ENV !== 'development') {
    return null;
  }

  if (!isVisible) {
    return (
      <div className="fixed bottom-4 right-4 z-50">
        <Button
          onClick={() => setIsVisible(true)}
          variant="outline"
          size="sm"
          className="bg-white shadow-lg"
        >
          🛠️ Debug
        </Button>
      </div>
    );
  }

  return (
    <div className="fixed bottom-4 right-4 z-50 w-80">
      <div className="bg-white rounded-lg border shadow-lg">
        <div className="p-4 pb-3 border-b">
          <div className="flex justify-between items-center">
            <h3 className="text-sm font-semibold">Debug Panel</h3>
            <Button
              onClick={() => setIsVisible(false)}
              className="h-6 w-6 p-0 bg-transparent text-gray-500 hover:text-gray-700 border-0"
              size="sm"
            >
              ✕
            </Button>
          </div>
        </div>
        <div className="p-4 space-y-3">
          <div>
            <h4 className="text-xs font-semibold mb-1">
              Статус аутентификации:
            </h4>
            <div className="text-xs space-y-1">
              <div>Статус: {session.status}</div>
              <div>Токен: {token ? '✅ Есть' : '❌ Нет'}</div>
              <div>Пользователь: {user?.email || 'Не авторизован'}</div>
            </div>
          </div>

          <div className="border-t pt-3">
            <h4 className="text-xs font-semibold mb-2">Тесты:</h4>
            <div className="space-y-2">
              <Test401Button className="w-full" />

              <Button
                onClick={() => window.open('/test-401', '_blank')}
                size="sm"
                className="w-full bg-transparent text-gray-700 border hover:bg-gray-50"
              >
                📄 Открыть тест-страницу
              </Button>

              <Button
                onClick={() => {
                  // eslint-disable-next-line no-console
                  console.clear();
                  // eslint-disable-next-line no-console
                  console.log('=== DEBUG INFO ===');
                  // eslint-disable-next-line no-console
                  console.log('Session:', session);
                  // eslint-disable-next-line no-console
                  console.log('Token:', token);
                  // eslint-disable-next-line no-console
                  console.log('User:', user);
                  // eslint-disable-next-line no-console
                  console.log('================');
                }}
                className="w-full bg-transparent text-gray-700 border hover:bg-gray-50"
                size="sm"
              >
                📋 Логи в консоль
              </Button>
            </div>
          </div>

          <div className="border-t pt-3">
            <CopyTokensHelper />
          </div>

          <div className="text-xs text-gray-500 border-t pt-2">
            💡 Этот панель видна только в dev режиме
          </div>
        </div>
      </div>
    </div>
  );
};
